import React from 'react';

interface Props {
	skalVises?: boolean;
	tekst: string;
}

function OppsummeringFeilmelding({ skalVises, tekst }: Props) {
	if (!skalVises) return null;
	return <p className="info-mangler">{tekst}</p>;
}

export { OppsummeringFeilmelding };
